export const REMOTE_CONFIG_KEYS = {
    ENABLED: 'blockjam_enabled',
    UNDO_ENABLED: 'blockjam_undo_enabled',
    GRID_SIZE_EASY: 'blockjam_grid_size_easy',
    GRID_SIZE_MEDIUM: 'blockjam_grid_size_medium',
    GRID_SIZE_HARD: 'blockjam_grid_size_hard',
    GRID_SIZE_EXPERT: 'blockjam_grid_size_expert',
    TARGET_MOVES_EASY: 'blockjam_target_solution_moves_easy',
    TARGET_MOVES_MEDIUM: 'blockjam_target_solution_moves_medium',
    TARGET_MOVES_HARD: 'blockjam_target_solution_moves_hard',
    TARGET_MOVES_EXPERT: 'blockjam_target_solution_moves_expert',
    MAX_UNDOS: 'blockjam_max_undos',
    ANIM_SLIDE_MS: 'blockjam_anim_slide_ms',
    ANIM_SHAKE_MS: 'blockjam_anim_shake_ms',
    ANIM_EXIT_MS: 'blockjam_anim_exit_ms',
    ANIM_CELEBRATION_MS: 'blockjam_anim_celebration_ms',
    // Module 96 — the reward curve, `round(base + perLevel × effective level)`.
    // Replaced the four `reward_level_complete_{easy,medium,hard,expert}` tiers.
    REWARD_BASE: 'reward_level_complete_base',
    REWARD_PER_LEVEL: 'reward_level_complete_per_level',
};
